import { Component, Injector, Optional, Input, ChangeDetectorRef } from '@angular/core';

import { RelatieService } from 'src/app/core/service/relatie.service';
import { Relatie } from 'src/app/core/dto/relatie';
import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType, TitleService } from '@mango/core';
import { FactuurType } from 'src/app/core/dto/factuur-type';
import { startWith, takeUntil } from 'rxjs/operators';
import { ThrowStmt } from '@angular/compiler';
import { ProjectregelService } from 'src/app/core/service/projectregel.service';

@Component({
    selector: 'c-i-j-borculo-relatie-collection',
    templateUrl: './relatie-collection.component.html'/*,
    styleUrls: ['./relatie-collection.component.css'] */
})
export class RelatieCollectionComponent extends PagedCollectionComponent<Relatie> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Relatie>([
		{ colDef: 'oldid', prop: x => x.oldID, searchable: SearchableType.String },
		{ colDef: 'exactNr', prop: x => x.exactNr, searchable: SearchableType.String },
		{ colDef: 'centixId', prop: x => x.centixId, searchable: SearchableType.String },
		{ colDef: 'naam1', prop: x => x.naam1, searchable: SearchableType.String },
		{ colDef: 'naam2', prop: x => x.naam2, searchable: SearchableType.String },
		{ colDef: 'tel1', prop: x => x.tel1, searchable: SearchableType.String },
		// { colDef: 'tel2', prop: x => x.tel2, searchable: SearchableType.String },
		{ colDef: 'eMail', prop: x => x.eMail, searchable: SearchableType.String },
		{ colDef: 'postPlaats', prop: x => x.postPlaats, searchable: SearchableType.String },
		{ colDef: 'verzendPlaats', prop: x => x.verzendPlaats, searchable: SearchableType.String },
		{ colDef: 'isRelatie', prop: x => x.isRelatie, searchable: SearchableType.Boolean },
		{ colDef: 'isLeverancier', prop: x => x.isLeverancier, searchable: SearchableType.Boolean },
		{ colDef: 'isProspect', prop: x => x.isProspect, searchable: SearchableType.Boolean },
		
    ]);

    displayedColumns = this.columnDefinitions.map(x => x.colDef);

	isRelatie: boolean = false;
	isLeverancier: boolean = false;
	isProspect: boolean = false;

    constructor(public service: RelatieService, @Optional() protected filter: Filter<Relatie>, injector: Injector, private titleService: TitleService, private projectregelService: ProjectregelService ) {
        super('/relatie/relatie', injector, Relatie);

		this.initInput('factuurtypeID', this.filterBuilder.equal(x => x.factuurtypeID.id));
		
    }

	
	ngOnInit() {
	
		// Init op 5000 -> ivm de mailing multiselect
		this.defaultPageSize = 5000;
		
        super.ngOnInit();

		// Indien niet aangeroepen in de multiselect dan overrule (en terug naar 50)
		if ((this.multiSelectData === null && this.multiSelectData === undefined )) {
			this.defaultPageSize = 50;
		}

		this.filter.onUpdate.pipe(takeUntil(this.onDestroy$),startWith(this.filter)).subscribe(x => {
			let fp1 = this.filter.getProperties().filter(fp => fp.p == "isRelatie")[0];
			let fp2 = this.filter.getProperties().filter(fp => fp.p == "isLeverancier")[0];
			let fp3 = this.filter.getProperties().filter(fp => fp.p == "isProspect")[0];
	
			let isRelatie = fp1 && fp1.v == true;
			let isLeverancier = fp2 && fp2.v == true;
			let isProspect = fp3 && fp3.v == true;
	
			if (isRelatie) {
				setTimeout(() => this.titleService.setCollectionTitle("Relaties"));
				this.isRelatie = true;
				this.isLeverancier = false;
				this.isProspect = false;
			} else if (isLeverancier) {
				setTimeout(() => this.titleService.setCollectionTitle("Leveranciers"));
				this.isLeverancier = true;
				this.isRelatie = false;
				this.isProspect = false;
			} else if (isProspect) {
				setTimeout(() => this.titleService.setCollectionTitle("Prospects"));
				this.isProspect = true;
				this.isRelatie = false;
				this.isLeverancier = false;
			} else {
				setTimeout(() => this.titleService.setCollectionTitle("Overig"));
			}
	
		});

		this.buildCustomActions(config => config.add({
			icon: 'download',
			name: "",
			pin: true,
			show: () => this.authScheme.canDo("CIJBorculo.Logic.RelatieExportRequest"),
			fn: () => this.DownloadExcel()
	  	}));

		this.filter.onGetChipLabel(x => x.oldID, () => 'Nummer');
		this.filter.onGetChipLabel(x => x.naam1, () => 'Naam');
		this.filter.onGetChipLabel(x => x.naam2, () => 'T.a.v.');
		this.filter.onGetChipLabel(x => x.tel1, () => 'Telefoon');
		this.filter.onGetChipLabel(x => x.tel2, () => 'Telefoon2');
		this.filter.onGetChipLabel(x => x.eMail, () => 'Email');
		this.filter.onGetChipLabel(x => x.postPlaats, () => 'Plaats');
		this.filter.onGetChipLabel(x => x.verzendPlaats, () => 'Verzenden');
		this.filter.onGetChipLabel(x => x.isRelatie, () => 'Relatie');
		this.filter.onGetChipLabel(x => x.isProspect, () => 'Prospect');
		this.filter.onGetChipLabel(x => x.isLeverancier, () => 'Leverancier');	
		this.filter.onGetChipLabel(x => x.exactNr, () => 'Exact');	
	
    }

	DownloadExcel() {
		this.service.downloadExcelFile(this.filter).toPromise().then(
			(value) => {
				if (value.successful) {
						var blob = this.projectregelService.ConvertResponseToBlob(value);
						var url = window.URL.createObjectURL(blob);
						let anchor = document.createElement('a');
						anchor.href = url;
						
						if (value.fileName) {
							anchor.setAttribute('download', value.fileName);
						}
						anchor.target = '_blank';
						anchor.click();
					}
					else {
						this.dialogs.snackAction("Het document is niet gevonden!", ()=>{},"ok", 3000);
					}
			});
	}

	displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are already filtered on
		if(colDef.colDef == 'factuurtypeID' && this.factuurtypeID != null) { return false; }
		if(colDef.colDef == 'centixId' && (this.isLeverancier || this.isProspect)) { return false; }

		return super.displayColumn(colDef, ix);
	}

	@Input() set factuurtypeID(val: FactuurType) { this.handleInput('factuurtypeID', val.id); }
	
	canDelete(){
		// Niet meer vanuit hier
		return false;		
	}
}